/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBranchAdminCreateInput } from "../../entities/models/BranchAdminCreateInput";
import { z } from "zod/v4";

export const modelsBranchAdminCreateInputSchema = z.object({
    "branch_id": z.int(),
"email": z.string(),
"name": z.string(),
"password": z.string().min(12).max(72)
    }) as unknown as z.ZodType<ModelsBranchAdminCreateInput>